import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import EmployeeFunctionalRoleModel from '../../../models/EmployeeFunctionalRoleModel';
import DataService from "../../../services/data.service";
import AddFunctionalRolePopup from '../Popups/Employee_popup_AddFunctionalRole';

interface Props {
    employeeId: number
}

const Employee_tab_FunctionalRoles: React.FC<Props> = ({ employeeId }) => {
    const [data, setData] = useState<EmployeeFunctionalRoleModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [employeeId]);

    function getTableData() {
        DataService.get<EmployeeFunctionalRoleModel[]>('api/v1/EmployeeFunctionalRoles/ByEmployee/' + employeeId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/EmployeeFunctionalRoles/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'functionalRoleId', visible: false },
        { title: 'Role', dataProp: 'functionalRole.name', sort: 'asc' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.EditFunctionalRoleForEmployee)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtEmployeeApplicationRoles'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Functional role'
                navigateUrl='/plm/UserManagement/FunctionalRole/'
            />
            {showPopup && (<AddFunctionalRolePopup employeeId={employeeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />)}

        </>
    );
}
export default Employee_tab_FunctionalRoles;